import type { AuditLog } from "@/types/audit";

import { api, unwrap } from "./axiosConfig";

export const auditService = {
  list(
    workspaceId: number,
    params?: { entity_type?: string; action?: string; limit?: number; offset?: number },
  ): Promise<AuditLog[]> {
    return unwrap(api.get(`/api/v1/workspaces/${workspaceId}/audit-logs`, { params }));
  },
};
